//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useEffect } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
const animatedComponents = makeAnimated();
const ChangeStatus = (props: any) => {
  const { gridData, handleStatusChange, defaultValue } = props;

  useEffect(() => {
    if (gridData?.length === 1 && !defaultValue?.length) {
      handleStatusChange([gridData[0]]);
    }
  }, [gridData, defaultValue, handleStatusChange]);

  return (
    <div className={tw`w-1/4`}>
      <span className={tw`text-primary font-semibold`}>Choose Next Status</span>
      <Select
        components={animatedComponents}
        closeMenuOnSelect={true}
        options={gridData}
        defaultValue={gridData?.length === 1 ? gridData : defaultValue}
        value={defaultValue}
        onChange={handleStatusChange}
        isMulti
      />
    </div>
  );
};

export default ChangeStatus;
